import React from 'react';
import StateCards from '../Hub/StateCards';

/**
 * Widget wrapper for StateCards
 * Provides state check-in UI (Mood, Energy, Focus, Space)
 */
export default function StateCardsWidget({ 
  currentState, 
  onStateChange, 
  onToast 
}) {
  return (
    <StateCards
      currentState={currentState}
      onStateChange={onStateChange}
      onToast={onToast}
    />
  );
}
